import React from "react";
import About1 from "../../../assets/images/OwnerCar.jpg";
import About2 from "../../../assets/images/about-2.jpg";
import Shape1 from "../../../assets/images/shape-11.png";
// import Signature from "../../../assets/images/signature-1.png";
import { Link } from "react-router-dom";
import { config } from "../config";

const AboutSection = () => {
  return (
    <div>
      <section className="about-section mt-md-0 mt-5">
        <div className="auto-container">
          <div className="row clearfix">
            <div className="col-lg-8 col-md-12 col-sm-12 big-column ">
              <div className="inner-box">
                <div className="title-text">
                  <h2>A Premier Driving School with Modern Vehicles</h2>
                </div>
                <div className="row clearfix align-items-center">
                  <div className="col-lg-6 col-md-6 col-sm-12 image-column">
                    <div className="image-box h-100">
                      <figure className="image h-100">
                        <img src={About1} alt="Precision Driving School" className="about-image-fill" />
                      </figure>
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-12 content-column">
                    <div className="content-box">
                      <h6>Since</h6>
                      <h2>2006</h2>
                      <div className="text about-text-compact">
                        <p>
                          At Precision Driving School, we've been helping learners across Leicester and the surrounding areas become safe, confident drivers for over 15 years.
                        </p>
                        <p>
                          Our experienced DVSA-approved driving instructors provide professional automatic driving lessons, manual driving lessons, intensive driving courses, and refresher driving lessons, tailored to every learner's ability and confidence level.
                        </p>
                        <p>
                          Whether you're learning to drive for the first time, preparing for your practical driving test, or returning to driving after a break, we provide structured lessons that help you progress with confidence.
                        </p>
                      </div>
                      <div className="inner">
                        {/* <figure className="signature">
                          <img src={Signature} alt="" />
                        </figure> */}
                        <div className="author">
                          <h4>Nelson Adomako</h4>
                          <span className="designation">Director</span>
                        </div>
                      </div>
                      <div className="btn-box">
                        <Link
                          to={`${config.appUrl}instructors`}
                          className="theme-btn btn-two"
                        >
                          Find an Instructor
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-12 col-sm-12 small-column position-relative">
              <div className="image-box">
                <div
                  className="shape"
                  style={{ backgroundImage: `url(${Shape1})` }}
                ></div>
                <figure className="image">
                  <img src={About2} alt="Precision Driving School" />
                </figure>
                {/* <div className="social-links">
                  <h6>Follow Me On</h6>
                  <ul className="social-list clearfix">
                    <li>
                      <a href="#">
                        <i className="bi bi-facebook"></i>
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i className="bi bi-twitter-x"></i>
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i className="bi bi-linkedin"></i>
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i className="bi bi-instagram"></i>
                      </a>
                    </li>
                  </ul>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutSection;
